import { Component } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";
import { map, switchMap, tap } from "rxjs/operators";
import { Reception } from "src/app/inventory/reception/reception";
import { ReceptionService } from "src/app/inventory/reception/reception-service";
import { NeedaConfig } from "src/app/inventory/supplier/needa-config";
import { SupplierService } from "src/app/inventory/supplier/supplier.service";
import { QuickbookService } from "src/app/quickbook/quickbook-service";
import { PurchaseOrder } from "../../order/purchase-order";
import { Invoice } from "../invoice";
import { InvoiceService } from "../invoice-service";

@Component({
  styleUrls: ['./invoice-details.component.css'],
  templateUrl: './invoice-details.component.html'
})
export class InvoiceDetailsComponent {
  public query = "";
  public needaConfig!: NeedaConfig;
  public invoice!: Invoice;
  public purchaseOrders!: PurchaseOrder[];
  public quickbookUrl!: string;
  public receptions!: Reception[];
  public needaInvoices!: string[];

  constructor(
    private invoiceService: InvoiceService,
    private quickbookService: QuickbookService,
    private receptionService: ReceptionService,
    private router: Router,
    private supplierService: SupplierService,
    activatedRoute: ActivatedRoute,
  ) {
    activatedRoute.paramMap.pipe(
      switchMap(paramMap => this.getInvoiceIdFromParams(paramMap)),
      switchMap(invoiceId => this.refreshInvoice(invoiceId)),
      switchMap(_ => this.quickbookService.getCompanyDetails()),
      tap(companyDetails => this.quickbookUrl = companyDetails.uiUrl),
    ).subscribe();
  }

  private getInvoiceIdFromParams(paramMap: ParamMap): Observable<string> {
    let purchaseOrderNumber = paramMap.get("invoice") || "";
    if (purchaseOrderNumber == "") {
      this.router.navigateByUrl("/404");

      return EMPTY;
    }

    return of(purchaseOrderNumber);
  }

  private getReception(): Observable<Reception[]> {
    return this.receptions != undefined ? of(this.receptions) : this.receptionService.newReceptionByInvoice(this.invoice.id).pipe(map(reception => [reception]));
  }

  public receive() {
    this.getReception()
      .pipe(map(receptions => receptions[0]))
      .subscribe(reception => this.router.navigateByUrl("/inventory/reception/" + reception.id));
  }

  private refreshInvoice(invoiceId: string): Observable<Invoice> {
    return this.invoiceService.findById(invoiceId)
      .pipe(
        tap(invoice => this.invoice = invoice),
        switchMap(purchaseOrder => this.supplierService.findNeedaConfig(purchaseOrder.supplier.id)),
        tap(needaConfig => this.needaConfig = needaConfig),
        tap(_ => this.refreshNeedaFiles()),
        tap(_ => this.refreshReception()),
        switchMap(_ => this.invoiceService.findPurchaseOrders(this.invoice.id)),
        tap(purchaseOrders => this.purchaseOrders = purchaseOrders),
        map(_ => this.invoice),
      );
  }

  private refreshNeedaFiles() {
    this.invoiceService.findNeedaFiles(this.invoice.id).subscribe(needaFiles => this.needaInvoices = needaFiles);
  }

  private refreshReception() {
    this.receptionService.findByInvoice(this.invoice.id).subscribe(receptions => this.receptions = receptions);
  }
}